
import { defineComponent } from 'vue';

const DEFAULT_LOGO_SRC = '';
const DEFAULT_LOGO_ALT = 'CAVU app logo';
const DEFAULT_TITLE = 'receipt.cavuMobileApp.manageBooking';
const DEFAULT_SUBTITLE = 'receipt.cavuMobileApp.officialPartner';

// This is a temporary default value until we build in the targeting logic to show the
// manage app CTAs.
// See https://magusa.atlassian.net/browse/CMA-149
const DEFAULT_DEEPLINK_URL = 'https://ca.vu/';

export default defineComponent({
  name: 'ReceiptMobileHeaderCta',

  components: {
    IconClose: () => import('@white-label-icon/icon-close'),
  },

  props: {
    deeplinkUrl: {
      type: String,
      default: null,
    },
    mode: {
      type: String as () => 'download' | 'manage',
      default: 'download',
    },
    logoSrc: {
      type: String,
      default: DEFAULT_LOGO_SRC,
    },
    logoAlt: {
      type: String,
      default: DEFAULT_LOGO_ALT,
    },
    title: {
      type: String,
      default: DEFAULT_TITLE,
    },
    subtitle: {
      type: String,
      default: DEFAULT_SUBTITLE,
    },
  },

  data() {
    return {
      isDismissed: false,
    };
  },

  computed: {
    ctaLabel(): string {
      const key = this.mode === 'manage'
        ? 'receipt.cavuMobileApp.open'
        : 'receipt.cavuMobileApp.get';
      return String(this.$t(key));
    },
    resolvedDeeplinkUrl(): string {
      return this.deeplinkUrl ?? DEFAULT_DEEPLINK_URL;
    },
  },

  methods: {
    dismiss() {
      this.isDismissed = true;
      this.$emit('dismiss');
    },
  },
});
